/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TokenInputs */

const en__field_token = /** @type {(inputs: _Field_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document token`)
};

/** @type {(inputs: _Field_TokenInputs) => LocalizedString} */
const de__field_token = en__field_token;

/**
* | output |
* | --- |
* | "Document token" |
*
* @param {_Field_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_token = /** @type {((inputs?: _Field_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_token(inputs)
	return de__field_token(inputs)
});